<template>
<div>
    <header>
        リアルタイム
        <div class="h-left">
            <a @click="redirectBack()"><img src="~@/assets/images/icon02.svg" /></a>
        </div>
    </header>
    <div id="wrap2">

        <div class="txt-area">
            <p class="b">募集日</p>
        </div>
        <div class="violation01 clearfix">
            <div class="real-select">
                <div id="real-select-btn" :class="`${timelineDetail && timelineDetail.created_at ? 'disable' : ''}`" @click="isShowDateDialog = true">
                    {{ date || "選択してください" }}
                </div>
            </div>
        </div>
        <div class="txt-area">
            <p class="b">投稿内容</p>
        </div>
        <form ref="form" style="padding-bottom: 50px">
            <div class="txt-area">
                <textarea @keyup="checkContent" :style="validate().style" v-model="content" :maxlength="contentMaxLength" class="self-introduction1" placeholder="募集内容を入力してください。"></textarea>
                <div class="clearfix">
                    <div class="self-introduction3">あと{{ content ? contentMaxLength - content.length : contentMaxLength }}文字</div>
                </div>
            </div>

            <div class="txt-area2 mycheckbox">
                <input v-model="isHideMatching" id="sample" type="checkbox">
                <label for="sample"></label>
                マッチング中の相手には表示しない
            </div>
            <div class="btn1" @click="submit"><a>投稿する</a></div>
        </form>
    </div>
    <successDialog :active="isAlert" @close="resetForm">
        <template v-slot:title>
            {{ alertTitle }}
        </template>
        <template v-slot:message>
            {{ alertMessage }}
        </template>
    </successDialog>
</div>
<div class="create loading-screen" v-if="isLoading">
    <div class="loader"></div>
</div>
<!-- <div class="datetime-picket">
    <div class="c1">
        <div class="blur-top"></div>
        <ul>
            <li v-for="item in 20" :key="item">{{item}}</li>
        </ul>
        <div class="blur-bottom"></div>
    </div>
    <div class="c2">
         <ul>
            <li v-for="item in 12" :key="item">{{item}}</li>
        </ul>
    </div>
    <div class="c3">
         <ul>
            <li v-for="item in 31" :key="item">{{item}}</li>
        </ul>
    </div>
</div> -->

  <SelectDateDialog
      v-if="isShowDateDialog"
      title="募集日"
      :date="date"
      @save="handleSelectDate"
      @close="closeSelectDateDialog"
  />
</template>

<script>
import {
    mapGetters
} from "vuex"
import successDialog from '@/views/components/successDialog'
import mixin from "@/mixin"
import CONSTANTS from "@/constants";
import SelectDateDialog from "./selectDateDialog.vue";
import { mapActions } from "vuex";
export default {
    components: {
        successDialog,
        SelectDateDialog
    },
    props: {
        timelineDetail: Object
    },
    emits: ['closeEdit'],
    mixins: [mixin],
    data: () => ({
        isSubmit: false,
        category: null,
        isValidate: false,
        isAlert: false,
        content: null,
        date: new Date(),
        isHideMatching: false,
        alertTitle: null,
        alertMessage: null,
        isLoading: false,
        contentMaxLength: 100,
        titleContent: 'リアルタイム投稿',
        msgOK: 'リアルタイムに投稿しました。管理者が24時間以内に確認します。',
        msgNG: 'リアルタイムに投稿できるのはひとりあたり一つです。',
        isShowDateDialog: false,
    }),
    computed: {
        ...mapGetters(['defaultToken']),
    },
    watch: {
        isShowDateDialog(val) {
            if (val) {
                this.setFooter(false)
                document.getElementsByTagName('body')[0].style.overflow = "hidden";
                document.getElementById('app').style.overflow = "hidden";
                document.getElementById('app').style.height = "calc(100vh - 1px)";
            }
            else {
                this.setFooter(true)
                document.getElementsByTagName('body')[0].style.overflow = "auto";
                document.getElementById('app').style.overflow = "";
                document.getElementById('app').style.height = "";
            }
        },
    },
    mounted() {
        this.date  = this.formatDateTime(this.date)

        if (this.timelineDetail && this.timelineDetail.created_at) {
            this.date = this.formatDateTime(this.timelineDetail.created_at)
            this.content = this.timelineDetail.content
        }

        window.scrollTo(0, 0)
    },
    methods: {
        ...mapActions({
        setFooter: "layout/setFooter",
        }),
        getDaysArray(start, end) {
            let days = [];
            for (let dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
                days.push(new Date(dt));
            }
            days = days.map((v) => {
                return this.formatDateTime(v);
            });
            return days;
        },
        redirectBack() {
            if (this.timelineDetail) {
                this.$emit('closeEdit')
            } else {
                this.$router.go(-1)
            }
        },
        checkContent() {
            if (this.content.length > this.contentMaxLength) {
                this.content = this.content.substr(1, this.contentMaxLength)
            }
        },
         resetForm() {
            this.isSuccess = false
            this.content = null
            this.date = this.formatDateTime(new Date())
            this.isValidate = false
            this.isAlert = false
        },
        validate() {
            if (!this.isValidate) return {
                style: null
            }
            if (!this.content) {
                    return {
                        style: "border-color: red",
                    }
                }
            return {
                style: null,
                submit: true
            }
        },
        async submit() {
            this.isValidate = true
            if (!this.validate().submit) return
            if (this.timelineDetail) {
                this.update()
                return
            }

            this.alertTitle = this.titleContent
            if (this.$store.getters.myTimelines[0]) {
                this.showAlert(this.msgNG)

            } else {
                this.isLoading = true
                let currentDate = this.getCurrentDate().replace('/', '-');;
                let params = {
                        free_at: currentDate,
                        page: 0,
                        limit: CONSTANTS.DEFAULT_PAGE_SIZE,
                        token: this.defaultToken,
                    };

                await this.$store.dispatch("timeline/getTimeline", params).then((data) => {
                    if (data.my_result[0]) {
                        this.showAlert(this.msgNG)
                    } else {
                        this.createTimeline();
                    }
                })
                .catch((err) => {
                    console.log('getTimeline error', err);
                });
            }
        },
        async createTimeline() {
            let formData = new FormData()
            formData.append('free_at', this.date)
            formData.append('content', this.content)
            formData.append('is_hide_matching', this.isHideMatching ? 1 : 0)
            formData.append('token', this.defaultToken)
            await this.$store.dispatch('timeline/createTimeline', formData).then((data) => {
                // data == -1 ==> not enough points => don't show alert
                if (data != -1) {
                    this.showAlert(this.msgOK)
                }
                this.isLoading = false
            }).catch(err => {
                // this.isAlert = true
                // this.alertMessage = err.response.data.message
            })
        },
        update() {
            let formData = new FormData() 
            formData.append('token', this.defaultToken)
            formData.append('content', this.content)
            formData.append('keijiban_id', this.timelineDetail.id)
            this.$store.dispatch('timeline/updateTimeline', formData).then(() => {
                this.$emit('closeEdit', this.content)
            }).catch()
        },
        showAlert(msg) {
            this.isAlert = true
            this.alertMessage = msg
            this.isLoading = false
        },
    
        handleSelectDate(selectedDate) {
            this.isShowDateDialog = false
            this.date = this.formatDateTime(selectedDate)
        },
        closeSelectDateDialog() {
            this.isShowDateDialog = false
        }
    }
};
</script>
<style scoped>
.datetime-picket{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    height: 30%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
}
.datetime-picket ul {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 200px;
    overflow: scroll;

    box-shadow: inset 1px 0px 0px 49px #fff;
}
.real-select input {
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
}
.mycheckbox label {
    padding-left: 0px !important;
    margin-right: 28px;
}
.mycheckbox {
    display: flex;
}
.create.loading-screen {
  background: #00000067;
}
.create .loader {
  border: 2px solid #fff;
  border-right-color: transparent;
}
.mycheckbox input[type="checkbox"]+label {
    display: none;
    cursor: pointer;
    display: inline-block;
    position: relative;
    padding-left: 0px;
    padding-right: 0px; 
    padding-top: 0px;
}
#real-select-btn{
  border: 1px solid black;
  padding: 6px;
  text-align: center;
  margin: 8px;
  border-radius: 4px;
}

#real-select-btn.disable{
  background-color: #dddddd;
  opacity: 0.7;
  border-color: rgb(66, 66, 66);
  pointer-events: none;
}
</style>
